"use client";

import type { Variant } from "@raumagarn/formatters";
import { YarnPreviewGrid } from "~/components/ui/YarnSelector/YarnPreviewGrid";
import { useVariantContext } from "~/features/products/VariantContext";
import styles from "./yarn-dropdown.module.css";

export type TYarnDropdownContent = {
	onVariantSelect?: (variant: Variant) => void;
	onSave?: () => void;
};

export const YarnDropdownContent = ({ onVariantSelect, onSave }: TYarnDropdownContent) => {
	const { currentVariant } = useVariantContext();

	// Save immediately on click so the customer doesn't have to scroll down
	// to a separate "Lagre farge" button after picking a color.
	const selectAndSave = (variant: Variant) => {
		onVariantSelect?.(variant);
		onSave?.();
	};

	return (
		<div className={styles.dropdown}>
			<div className={styles["section-label"]}>
				{currentVariant && (
					<p>
						Farge
						<span>
							{currentVariant?.name} ({currentVariant?.displayItemId})
						</span>
					</p>
				)}
			</div>
			<YarnPreviewGrid onVariantSelect={selectAndSave} />
		</div>
	);
};
